import { Alert, Typography } from "@mui/material";
import { TableData, TableDataProps } from "../TableData";

export const BeroepsI1a1May17 = (props: TableDataProps) => {
  return (
    <>
      <Alert
        severity="error"
        sx={{ mb: 2, alignItems: "center", textAlign: "left" }}
      >
        <Typography variant="h3">
          Verwerk eerst even de werkprocessen/logboeken van de voorgaande
          cruise! <br /> Stuur deze vervolgens naar meneer moslèh@glr.nl
        </Typography>
      </Alert>

      <TableData data={props.data} />
    </>
  );
};
